import {
    SkyNetObjectConfigParams,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    EngagementTableType,
} from 'app/Apps/RelationshipsManagement/Engagement/engagement.types'
import {
    AttitudeToSkyCell,
} from 'app/enums/label.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RequestConfig,
} from 'app/types/request.types'
import EngagementRequests from 'app/requests/Engagement.requests'
import {
    SkyDataGridColumnDefinition,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'

import EngagementDemoOverview from './EngagementDemoOverview'
import EngagementDemoEditForm from './EngagementDemoEditForm'
import EngagementsDemoCreate from './EngagementsDemoCreate'
import EngagementsDemoBulkUploadPopup from './EngagementsDemoBulkUploadPopup'

const columns: SkyDataGridColumnDefinition<EngagementTableType>[] = [
    {
        name: 'contactName',
        reduced: true,
        labelKey: 'NAME_AND_SURNAME',
    },
    {
        name: 'contactCompanyName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'COMPANY',
    },
    {
        name: 'contactCountryName',
        filterType: FilterType.Array,
        labelKey: 'BASED_IN_COUNTRY',
    },
    {
        name: 'attitudeToSkyCell',
        filterType: FilterType.Array,
        componentName: 'AttitudeToSkyCellTable',
        allowedValuesEnum: AttitudeToSkyCell,
        labelKey: 'ATTITUDE_TO_SKYCELL',
    },
]

const formViews = [
    {
        label: 'Overview',
        url: CommonRoutes.Overview,
        Component: EngagementDemoOverview,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: EngagementRequests.get,
            requestKey: RequestKeys.getEngagement,
        },
    },
    {
        label: 'Data Update',
        url: CommonRoutes.Update,
        Component: EngagementDemoEditForm,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: EngagementRequests.get,
            requestKey: RequestKeys.getEngagement,
        },
    },
]

const request: RequestConfig = {
    url: 'engagement/filter-request/all',
    method: 'POST',
}

const requestProspect: RequestConfig = {
    url: 'engagement/filter-request/prospect',
    method: 'POST',
}

const engagementDomainConfig: SkyNetObjectConfigParams<EngagementTableType> = {
    persistentKey: 'demo-engagements-table',
    defaultTab: 1,
    formViews,
    columns,
    config: [
        {
            url: CommonRoutes.All,
            name: 'Prospect Contacts',
            requestKey: RequestKeys.getProspectEngagements,
            request: requestProspect,
            actionComponents: {
                Create: {
                    component: EngagementsDemoCreate,
                    accessOnly: ['relationships_sales'],
                },
                BatchUpdate: {
                    component: () => {
                        return <EngagementsDemoBulkUploadPopup name="prospects" />
                    },
                },
            },
        },
        {
            url: 'contacts',
            name: 'Contacts',
            /*  Need to use unique key for each request */
            requestKey: RequestKeys.getEngagements,
            request: {
                ...request,
                data: {
                    includeFilters: {
                        contactIsProspect: [false],
                    },
                },
            },
            actionComponents: {
                Create: {
                    component: EngagementsDemoCreate,
                    accessOnly: ['relationships_sales'],
                },
                BatchUpdate: {
                    component: () => {
                        return <EngagementsDemoBulkUploadPopup name="contacts" />
                    },
                },
            },
        },
    ],
}

export default engagementDomainConfig
